
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import PromptSignInDialog from "./PromptSignInDialog";
import SavePromptButton from "./SavePromptButton";
import { analytics } from "@/services/analytics/analyticsService";
import { toast } from "sonner";

interface PromptActionsProps {
  id: string;
  title: string;
  content: string;
  isCopied: boolean;
  onCopy: (e: React.MouseEvent) => void;
  category?: string;
}

const PromptActions = ({
  id,
  title,
  content,
  isCopied,
  onCopy,
  category,
}: PromptActionsProps) => {
  const [showSignInDialog, setShowSignInDialog] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCopyClick = (e: React.MouseEvent) => {
    if (!user) {
      setShowSignInDialog(true);
      return;
    }
    // Track the copy event
    analytics.trackPromptCopy(id, title, category);
    onCopy(e);
  };

  const handleSignInClose = () => {
    setShowSignInDialog(false);
  };

  const handleNavigateToSignIn = () => {
    setShowSignInDialog(false);
    navigate('/sign-in');
  };

  return (
    <>
      <div className="flex gap-3 flex-wrap">
        <SavePromptButton promptId={id} promptTitle={title} isLarge={true} />

        <Button
          variant="default"
          className="flex items-center gap-2"
          onClick={handleCopyClick}
        >
          {isCopied ? (
            <>
              <Check className="h-5 w-5" />
              Copied!
            </>
          ) : (
            <>
              <Copy className="h-5 w-5" />
              Copy Prompt
            </>
          )}
        </Button>
      </div>

      <PromptSignInDialog
        open={showSignInDialog}
        onOpenChange={handleSignInClose}
        onSignIn={handleNavigateToSignIn}
      />
    </>
  );
};

export default PromptActions;
